export enum PriceWidgetTypes {
  Cheap = 'Cheap',
  Middle = 'Middle',
  High = 'High'
}

export enum DepartureWidgetTypes {
  Morning = 'Morning',
  Afternoon = 'Afternoon',
  Evening = 'Evening'
}

export enum FlightDurationWidgetTypes {
  Low = 'Low',
  Intermediate = 'Intermediate',
  High = 'High'
}

export enum AmenitiesWidgetTypes {
  Wifi = '223',
  Gym = '35',
  Pool = '71',
  Parking = '68'
}
